import {useState, useEffect } from 'react';
import axios from 'axios';
import AuthContext from './AuthContext';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    token: localStorage.getItem('token') || null,
    isAuthenticated: false,
    loading: true,
    msg: null
  });

  const login = async (credentials) => {
    let dataResponse = {};
    try {
        const t = _.get(credentials, 'token.token', "");
        const response = await fetch('/wp-json/unlock/custom-auth/v1/login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.wpSettings.nonce
            },
            body: JSON.stringify(
                {'token': t },
            )
        })  .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                // console.log('✅ Response from API:', data);
                dataResponse = data;
            })
            .catch(error => {
                // console.error('❌ API Error:', error);
            });
      const token = dataResponse.token;
      const success = dataResponse.success;
      const message = dataResponse.message;
      const valid = dataResponse.valid;
      const uuid = dataResponse.uuid;
      if (success && valid) {
        localStorage.setItem('token', token);
        localStorage.setItem('UUID', uuid);

        setAuth({
            token,
            isAuthenticated: true,
            loading: false,
            msg: message
        });
        window.location.href = '/';
        return true;
      }
      setAuth({
        token: null,
        isAuthenticated: false,
        loading: false,
        msg: message
      });
      return false;
    } catch (error) {
      // console.error('Login failed:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setAuth({
      token: null,
      isAuthenticated: false,
      loading: false,
      msg: ""
    });
    // Redirect to home page
    window.location.href = '/unlock';
  };

  const verifyToken = async () => {
    try {
      const response = await axios.post(
        '/wp-json/custom-auth/v1/verify',
        {},
        {
          headers: {
            'Authorization': `Bearer ${auth.token}`
          }
        }
      );
      
      setAuth(prev => ({
        ...prev,
        isAuthenticated: true,
        loading: false
      }));
    } catch (error) {
      logout();
    }
  };

  useEffect(() => {
    if (auth.token) {
      verifyToken();
    } else {
      setAuth(prev => ({ ...prev, loading: false }));
    }
  }, []);

  return (
    <AuthContext.Provider value={{ auth, setAuth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;